var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlusCircle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 26,
    viewBox: "0 0 24 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6608_6495)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 8.43506,
    height: 8.43506,
    transform: "matrix(0.670636 -0.741787 0.670636 0.741787 6.34375 13.1289)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.34435 6.87189C3.22522 10.3219 3.22522 15.9359 6.34435 19.3859C9.46349 22.836 14.5389 22.836 17.6581 19.3859C20.7772 15.9359 20.7772 10.322 17.6581 6.87189C14.5389 3.42183 9.46349 3.42183 6.34435 6.87189ZM15.9105 12.3916C16.0946 12.3916 16.2438 12.5566 16.2438 12.7603L16.2438 13.4975C16.2438 13.7011 16.0946 13.8662 15.9105 13.8662L12.6678 13.8662L12.6678 17.453C12.6678 17.6566 12.5186 17.8216 12.3345 17.8217L11.6679 17.8217C11.4838 17.8217 11.3346 17.6566 11.3346 17.453L11.3346 13.8662L8.09188 13.8662C7.90777 13.8663 7.75852 13.7012 7.75854 13.4975L7.75852 12.7603C7.75857 12.5566 7.90777 12.3916 8.09188 12.3916L11.3346 12.3916L11.3346 8.80482C11.3346 8.60117 11.4838 8.43614 11.6679 8.43609L12.3345 8.43612C12.5186 8.43607 12.6678 8.60115 12.6678 8.80482V12.3916L15.9105 12.3916Z",
    fill: "#7195AD"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6608_6495"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16.8701,
    height: 16.8701,
    fill: "white",
    transform: "matrix(0.670636 -0.741787 0.670636 0.741787 0.6875 13.1289)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusCircle);
export default __webpack_public_path__ + "static/media/plus-circle.a87e4c08b0779071e7a89aa801c3e50b.svg";
export { ForwardRef as ReactComponent };